import PopupResponsive from '@/components/PopupResponsive';

export default function ExplainDialog({
  children,
  open,
  ...props
}: {
  open: boolean;
  children: React.ReactNode;
  [key: string]: any;
}) {
  return (
    <PopupResponsive open={open} {...props}>
      <div className="f13">{children}</div>
    </PopupResponsive>
  );
}
